// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"625cc576","347":"1649a14f","400":"8923aa06","422":"c76acb1d","481":"ab33b488","526":"483830b7","904":"6e6b6cf9"}[chunkId] + ".chunk.js";
};